export const selectAppraiserSpecializationsData = (state) => state.appraiserSpecializations.data
export const selectAppraiserSpecializationsStatus = (state) => state.appraiserSpecializations.status
export const selectAppraiserSpecializationsError = (state) => state.appraiserSpecializations.errorMessage
